import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledNoData = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue400',
  display: 'flex',
  fontSize: '$xl',
  fontWeight: '$bold',
  height: '200px',
  lineHeight: '$8',
  margin: 'auto',
  width: '130px',
});
